import Repository from "./Repository";

export default {

    uploadProfileImage(files){
        return Repository.new().postFile("/changeimage", files, {});
    },

    uploadFile(files,email,emails,message,permissions,temporaryPermissionType,temporaryPermissionValue,givePermissionList,capchaToken,files_connected,user_name){
        return Repository.new().postFile("/files", files, {email:email,emails:emails,message:message,permissionsList:permissions,temporaryPermissionType:temporaryPermissionType,givePermissionList:givePermissionList,temporaryPermissionValue:temporaryPermissionValue, capchaToken:capchaToken, files_connected: files_connected, user_name:this.user_name});
    },

    shareFile(files_hash, emails, message, permissions,temporaryPermissionType,temporaryPermissionValue, givePermissionList, token = null){
        return Repository.new().auth(token).post("/share", {files_hash: [files_hash], emails:emails,
            message:message, permissionsList: permissions, temporaryPermissionType: temporaryPermissionType,
            temporaryPermissionValue: temporaryPermissionValue, givePermissionList: givePermissionList}
        );
    },

    unshareFile(files_hash, emails, message, permissions,temporaryPermissionType,temporaryPermissionValue, givePermissionList, token = null){
        return Repository.new().auth(token).post("/share", {files_hash: [files_hash], emails:emails,
            message:message, permissionsList: permissions, temporaryPermissionType: temporaryPermissionType,
            temporaryPermissionValue: temporaryPermissionValue, givePermissionList: givePermissionList, unsharing: true}
        );
    },

    getFile(hash, token = null){
        return Repository.new().auth(token).getFile("/files/" + hash);
    },

    getFileJson(hash, token = null) {
        return Repository.new().auth(token).get("/files/" + hash);
    },

    getFilePage(pdf_access_token, token, page){
        return Repository.new().auth(token).getFile("/files/page/" + pdf_access_token + "/" + page);
    },

    getOriginalFile(hash, token = null){
        return Repository.new().auth(token).getFile("/files/download/" + hash);
    },

    getFileInfo(hash, token = null){
        return Repository.new().auth(token).get("/files/info/" + hash);
    },

    getFileDetails(hash, token = null){
        return Repository.new().auth(token).get("/files/details/" + hash);
    },

    getLmvTokens(hash, token = null){
        return Repository.new().auth(token).get("/files/lmv/" + hash);
    },

    getComments(hash, token = null){
        return Repository.new().auth(token).get("/comments/" + hash);
    },

    checkTrackerAccess(hash, token = null){
        return Repository.new().auth(token).get("/tracker-access/" + hash);
    },

    getFileCounters(hash) {
        return Repository.new().get("/files/counters/" + hash);
    },

    getMyFiles(search, page, limit, order, owner){
        let skip = Math.max(0, page - 1) * limit;
        return Repository.new().cancellable().get("/list/files", {search: search, limit: limit, skip: skip, order: order, owner: owner});
    },

    requestAccess(hash, token = null){
        return Repository.new().auth(token).post("/request-access/" + hash);
    },


};